/** Card audit rows (CREATED / UPDATED / REMOVED) as text for the history lists; who did it is shown beside. */

const FIELD_LABELS = { nickname: 'Nickname', expiry: 'Expiry' };
export const ACTOR_LABELS = { TC_USER: 'staff', PORTAL_USER: 'customer portal' };

// One audit row as a sentence: what happened (and what changed) — the actor is shown separately.
export const describeCardEvent = (e) => {
  if (e.action === 'CREATED') return 'Added';
  if (e.action === 'REMOVED') return 'Removed';
  if (e.action === 'UPDATED') {
    const changes = Object.entries(e.details?.changes || {})
      .map(([k, { from, to }]) => `${FIELD_LABELS[k] || k}: ${from || '—'} → ${to || '—'}`);
    return changes.length ? `Changed ${changes.join(', ')}` : 'Changed';
  }
  return String(e.action || '').replace(/_/g, ' ').toLowerCase();
};
